export const PRODUCTS_PREFIX = "@PRODUCTS/"
export const FETCH_PRODUCTS = `${PRODUCTS_PREFIX}FETCH_PRODUCTS`
